import { SagaIterator } from '@redux-saga/core'
import { all, put, call, takeLatest } from 'redux-saga/effects'
import { CONTENT } from 'ducks/voluntariadoLayout'
import { Action } from 'lib/redux/models'
import getVoluntariadoLayout from 'services/getVoluntariadoLayout'

function* loadVoluntariadoLayout(action: Action) {
  yield put(CONTENT.request())
  try {
    const { data } = yield call(getVoluntariadoLayout, action?.payload)
    if (data) {
      yield put(CONTENT.success(data.voluntariadoLayout))
    }
  } catch (error) {
    yield put(CONTENT.failure(error.message))
  } finally {
    yield put(CONTENT.fulfill())
  }
}

export function* voluntariadoLayoutSagas(): SagaIterator {
  yield all([takeLatest(CONTENT.TRIGGER, loadVoluntariadoLayout)])
}
